import { createAction } from 'redux-actions';
import { reduxKey } from './constants';

export const newChatMessage = createAction(
  `${reduxKey}.NEW_CHAT_MSG`,
  () => ({})
);
